'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingBar = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _LoadingBarStyle = require('./LoadingBar.style.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingBar = exports.LoadingBar = function LoadingBar(_ref) {
  var className = _ref.className,
      max = _ref.max,
      min = _ref.min,
      mode = _ref.mode,
      value = _ref.value;
  return _react2.default.createElement(
    'div',
    { className: className, style: { width: '100%', height: '2px' } },
    _react2.default.createElement('div', {
      className: 'bar',
      style: mode === 'determinate' ? { width: (0, _LoadingBarStyle.getRelativeValue)(value, min, max) + '%' } : null
    })
  );
};

LoadingBar.propTypes = {
  /**
   * The string to determine the color of the bar background. Defaults to theme ternary
   */
  backgroundColor: _propTypes2.default.string, //eslint-disable-line
  /**
   * This property is required to apply glamorous styles to the component.
   * It is not necessary to add a className, but it will be merged with the glamorous className if you do
   */
  className: _propTypes2.default.string, //eslint-disable-line
  /**
   * The string to determine the color of the indicator. Defaults to theme primary
   */
  color: _propTypes2.default.string, //eslint-disable-line
  /**
   * The max value of progress - only works in determinate mode
   */
  max: _propTypes2.default.number, //eslint-disable-line
  /**
   * The min value of progress - only works in determinate mode
   */
  min: _propTypes2.default.number, //eslint-disable-line
  /**
   * The string to determine spinner mode. Provide value if set to 'deterministic'
   */
  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']), //eslint-disable-line
  /**
   * The value of progress - only works in determinate mode
   */
  value: _propTypes2.default.number //eslint-disable-line
};

var _LoadingBar = (0, _glamorous2.default)(LoadingBar)(_LoadingBarStyle.defaultStyle, _LoadingBarStyle.mapPropsAndThemeToStyle);

_LoadingBar.defaultProps = {
  min: 0,
  max: 100,
  mode: 'indeterminate',
  value: 0
};

exports.default = _LoadingBar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/LoadingBar/LoadingBar.js
// module id = 552
// module chunks = 0